export enum InAppPurchaseStatus {
  none = 0,
  pending = 1,
  purchased = 2,
  error = 3,
  restored = 4,
  canceled = 5,
  paused = 6,
  expired = 7,
}

export const isActiveStatus = (status: InAppPurchaseStatus): boolean => {
  return status === InAppPurchaseStatus.purchased || status === InAppPurchaseStatus.restored;
};
